module.exports = __webpack_public_path__ + "static/media/document.5fad301f.svg";